import React, {Component} from 'react';
import {config, SERVICE_API, VIEW_NAME,DISPATCH_ID} from '../libs/utils/Const';
import {connect} from "react-redux";
import {ItemDetailsModal, Pagination, Paginations} from "./index";
import CurrencyFormat from 'react-currency-format';

class ItemsList extends Component {

    state = { currentPage: null }

    // changeQuantity = (index, item, event) =>{
    //     const {changeQuantity} = this.props;
    //     let newQuantity =  event.nativeEvent.target.value;
    //     let onHand = item.OnHand;
    //     if(newQuantity > onHand) {
    //         newQuantity = onHand;
    //     }
    //         if(!newQuantity){
    //             changeQuantity(index,item, newQuantity, false); //delete
    //         }else{
    //             changeQuantity(index,item, newQuantity, true); // add
    //         }
        
    // };

    changeQuantity = (index, item, event) =>{
        const {changeQuantity, itemsReducer: {items: itemsSearch}} = this.props; 
        
        let newQuantity;
        itemsSearch.map( itemFilter => {
            if (itemFilter.ItemCode === item.ItemCode) {
                newQuantity = itemFilter.quantity || '1';
            }
        });
        
        let onHand = item.OnHand;
        if(Number(newQuantity) > Number(onHand)) {
            newQuantity = onHand;
        }   

        // color azul rinti
        document.getElementById(item.ItemCode).style.backgroundColor = "#005DA8";
        document.getElementById(item.ItemCode).style.borderColor = "#005DA8";

        if(!newQuantity){
            changeQuantity(index,item, newQuantity, false); 
        }else{
            changeQuantity(index,item, newQuantity, true); 
        }        
    };

    changLocalQuantity = (index, item, event)=>{
        const {shoppingCartReducer: {items},itemsReducer: {items: itemsSearch}} = this.props;
        let newQuantity =  event.nativeEvent.target.value;
        if(newQuantity < 0){
            newQuantity = 1
        }
        // color success
        document.getElementById(item.ItemCode).style.backgroundColor = "#28a745"; 
        document.getElementById(item.ItemCode).style.borderColor = "#28a745"; 
        
        if (newQuantity % 1 == 0) {
            // console.log('con<<<<',newQuantity);
            itemsSearch.map( itemFilter => {
                if (itemFilter.ItemCode === item.ItemCode) {
                    itemFilter.quantity = newQuantity;
                }
            });
            this.applyFilters(itemsSearch);
        } else {
            return;
        }  
    }
    
    applyFilters = data => {
        const {setItemsFilterSearch} = this.props;
        // enableSpinner(true);
        setItemsFilterSearch(data);
        // enableSpinner(false);

        // $("#menuCategories").removeClass('open-menu-categories');
    };

    // searchPage = async ( page = 0)=>{
    //     const {itemsReducer} = this.props;
    //     await itemsReducer.searchByKey(page);
    // }
    searchPage = async ( page = 0)=>{
        const { setNextPage, itemsReducer: {searchByCategories,searchByKey,category,idCategory,location,searchByDash, searchByDashOption, typeSearch},items} = this.props;
        page = page === 1 ? 0 : ((page -1) * 10);
        if(location ==='menuCategories'){
            setNextPage(page);
            await searchByCategories(idCategory,page);
        }else if(location === 'navBar'){
            await searchByKey(page,typeSearch);
        }else if(location === 'dash'){
            // console.log('con°-° OPCION', searchByDashOption);
            await searchByDash(searchByDashOption, page);
        }
    }

    onPageChanged = async data => {
        const {itemsReducer} = this.props;
        const { currentPage,nextPage, totalPages} = data;
        await itemsReducer.searchByKey(nextPage,itemsReducer.typeSearch);
        this.setState({ currentPage, totalPages });
    }

    render() {
        const {items, changeBackOrder, updateFavorite, deleteShoppingCart, openDetails,itemsReducer:{TotalPage}} = this.props;
        const {currentPage} = this.state;
        return (
            <div>
                <div className="container-fluid row" style={{
                paddingTop: 30, margin: 0, display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <ItemDetailsModal view={VIEW_NAME.ITEMS_VIEW}/>
                {items.map((item, index) => {
                    // console.log("con< ITEM ======== >",item.ItemCode , item.OnHand, item.priceTax);
                    item.ItemName = item.ItemName || '';

                    return (
                        <div style={{margin: 12, position: 'relative', textAlign: 'center'}} key={item.ItemCode + item.ItemName + item.Price}>
                            <div className="item card" style={{ width: '16rem', padding: 5, backgroundColor: config.itemsList.backgroundColor}}>
                                <div>
                                    <div style={{
                                        display: (item.OnHand >= 1 ? 'none' : item.OnHand === '0.0' ? 'none' : 'table'),
                                        position: 'absolute',
                                        color: config.navBar.textColor,
                                        backgroundColor: 'red',
                                        width: '13.3rem',
                                        borderBottomRightRadius: 25
                                    }}>
                                        Agotado
                                    </div>
                                    <img
                                        onClick={() => openDetails(item)}
                                        className="card-img-top"
                                        style={{
                                            width: '15rem',
                                            height: '15rem',
                                            backgroundColor: 'white',
                                            cursor: 'pointer'
                                        }}
                                        src={item.PicturName ? (config.BASE_URL + SERVICE_API.getImage + '/' + item.PicturName) : require('../images/noImage.png')}
                                        alt=""
                                    />
                                    <div className="card-body" style={{margin: 0, padding: 0, color: config.itemsList.textColor}}>
                                        <div className="overflow-auto">
                                            <p className="card-title font-weight-bold text-left" style={{margin: 0, padding: 0, fontSize: 14, height: '3rem'}}>
                                                {/*item.ItemName.length > 43 ? item.ItemName.substring(0, 42 ) + "..." : item.ItemName*/}
                                                {item.ItemName}
                                            </p>
                                        </div>
                                        <div className='row'>
                                            <div className='col-12' style={{padding: 8}}>
                                                <h6 className="card-subtitle text-left" style={{fontSize: 12, marginLeft: 3}}>{item.ItemCode}</h6>
                                                <h6 className="card-subtitle font-weight-bold text-left" style={{fontSize: 16, margin: 2, color: config.itemsList.textPrice}}>
                                                    {item.U_web === 0 || item.U_web === null || item.OnHand === '0.0'? 
                                                        "Solicite su cotización" : 
                                                        // <CurrencyFormat 
                                                        //     value={item.Price} 
                                                        //     displayType={'text'} 
                                                        //     thousandSeparator={'.'}
                                                        //     decimalSeparator={','}
                                                        //     prefix={config.general.currency}>
                                                        // </CurrencyFormat>

                                                            <CurrencyFormat 
                                                                value={item.priceTax} 
                                                                displayType={'text'} 
                                                                thousandSeparator={true} 
                                                                fixedDecimalScale={true} 
                                                                decimalScale={2} 
                                                                prefix={config.general.currency}>
                                                            </CurrencyFormat>
                                                    }
                                                    {/* {item.U_web === 1 && 
                                                       " más I.G.V."
                                                    } */}
                                                </h6>
                                            </div>
                                            <div className='col-3' style={{ padding: 0, margin: 0,}}>
                                                <div onClick={() => updateFavorite(item)} style={{ padding: 0}}>
                                                    {/*<i
                                                        className={config.icons.favorite}
                                                        aria-hidden="true"
                                                        style={{
                                                            cursor: 'pointer',
                                                            padding: 0,
                                                            margin: 0,
                                                            marginTop: 9,
                                                            fontSize: 30,
                                                            zIndex: 10,
                                                            color: item.favorite ? config.itemsList.iconColor : 'rgba(124, 124, 125, 0.5)',
                                                        }}
                                                    />*/}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <div className='row text-center' style={{margin: 0, padding: 0}}>
                                        {item.U_web === 0 || item.U_web === null ? 
                                            <div className='col-12' style={{padding:0}}>
                                                <label style={{textAlign: 'center', fontSize: 16}}>Llámenos o envíe un correo</label>
                                            </div> : 
                                            <div className='col-10' style={{padding:0}}>
                                                    <input
                                                        //disabled={!(!!item.OnHand)}
                                                        disabled={item.OnHand >=1 ? false : item.OnHand === '0.0' ? true : true }
                                                        // disabled={item.OnHand >=1 && item.quantity != '' ? false : item.OnHand === '0.0' ? true : true }
                                                        id={'input-quantity-' + item.ItemCode + index}
                                                        type="number"
                                                        pattern="[0-9]+"
                                                        min="1"
                                                        value={item.quantity ? Number(item.quantity) : ''}
                                                        className="form-control"
                                                        name={'quantity' + item.ItemCode}
                                                        placeholder="Cantidad"
                                                        style={{textAlign: 'center', marginTop: 1, height: 30}}
                                                        // onChange={(event) => {this.changeQuantity(index, item, event)}}
                                                        onChange={(event) => {this.changLocalQuantity(index, item, event)}}
                                                        //onKeyDown={event => event.keyCode == 13 && this.addShoppingCart(item, 'input-quantity-' + item.ItemCode + index)}
                                                    />
                                            </div>
                                        }
                                        {item.U_web === 1 &&
                                            <div className='col-2' style={{color: 'red', fontSize: 20,padding:0}}>
                                                {item.quantity && <i className={config.icons.trash} style={{cursor: 'pointer'}} onClick={() =>  deleteShoppingCart({item, deleteAll: false})}/>}
                                            </div>
                                        }
                                    </div>
                                    {item.U_web === 0 || item.U_web === null ? 
                                    <div><label style={{textAlign: 'center', fontSize: 16}}>para cotización</label></div>:
                                    <div className="pt-1">
                                        <button type="button" disabled={item.OnHand >=1 ? false : item.OnHand === '0.0' ? true : true } style={{backgroundColor : item.quantity != '' ?  '#005DA8' : '', borderColor : item.quantity != '' ?  '#005DA8' : ''}}  id={item.ItemCode} className="btn btn-success btn-block" value={(item.quantity ? Number(item.quantity): '1')} onClick={(event)=>{this.changeQuantity(index, item, event)}}>
                                            <i className={config.icons.add}/> Agregar al carrito
                                        </button>
                                    </div>}
                                    <div className='row text-center' style={{margin: 0, padding: 0}}>
                                        {item.U_web === 0 || item.U_web === null ?
                                            item.wishlist === 1 &&
                                            <div className='col-12' style={{padding:0}}>
                                                <label style={{textAlign: 'center', fontSize: 16}}>para cotización</label>
                                            </div> :
                                            item.wishlist === 1 &&
                                                <div className='col-10'>
                                                    <label style={{textAlign: 'center', marginTop: 12, fontSize: 14}}>Lista de deseos</label>
                                                </div>
                                        }
                                        {item.U_web === 1 &&
                                            item.wishlist === 1 &&
                                                <div className='col-2' style={{color: config.navBar.backgroundColor, fontSize: 20, padding: 0}}>
                                                    {item.backOrder ? 
                                                        <i className={config.icons.backOrderFalse} style={{cursor: 'pointer', marginLeft: 7, marginTop: 15}} onClick={() => changeBackOrder(item, false)}/> :
                                                        <i className={config.icons.backOrderTrue} style={{cursor: 'pointer', marginLeft: 7, marginTop: 15}} onClick={() => changeBackOrder(item, true)}/>
                                                    }
                                                </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    );

                })}
            </div>
            
                <div className="row"> 
                    <Pagination
                    refresh ={this.searchPage}
                    totalRowsRefresh = {TotalPage}
                    />
                </div>
                {/* <div class="row">
                    <div className="col-sm">
                    </div>
                    <div className="row justify-content-center col-sm">
                        <Paginations totalRecords={TotalPage} pageLimit={10} pageNeighbours={1} onPageChanged={this.onPageChanged}/>
                    </div>
                    <div className="row justify-content-right col-sm">
                        { currentPage && (
                            <span className="current-page d-inline-block h-100 pl-4 text-secondary">
                            Página <span className="font-weight-bold">{ currentPage }</span> / <span className="font-weight-bold">{  Math.ceil(TotalPage/10)}</span>
                            </span>
                        ) }
                    </div>
                </div> */}
            </div>
        );
    }
}

// export default ItemsList;
const mapStateToProps = store => {
    return {
        notificationReducer: store.NotificationReducer,
        shoppingCartReducer: store.ShoppingCartReducer,
        itemsReducer: store.ItemsReducer,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setShoppingCart: value => dispatch({type: DISPATCH_ID.SHOPPING_CART_SAVE_CART, value}),
        setItemsFilterSearch: value => dispatch({type: DISPATCH_ID.ITEMS_SAVE_ITEMS_FILTER, value}),
        setNextPage:  value => dispatch({type: DISPATCH_ID.ITEMS_SET_NEXTPAGE, value}),
        searchByDashOption: value => dispatch({type: DISPATCH_ID.ITEMS_SET_SEARCH_BY_DASH_OPTION, value}),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ItemsList);
